export const experiense = [
    {
        date: "Totalidade",
        title: "Integração Completa",
        category: "Completude",
        description: "O Parceirando é a única ferramenta que oferece uma solução completa de ponta a ponta, desde a captura de leads até a conversão final. Isso permite que afiliados tenham controle total sobre o processo de vendas, sem a necessidade de múltiplas plataformas ou scripts adicionais."
    },
    {
        date: "Insights",
        title: "Relatórios e Análises",
        category: "Transparência",
        description: "Os afiliados têm acesso a relatórios, permitindo acompanhar o desempenho e identificar oportunidades de melhoria. A transparência nos dados facilita a tomada de decisões estratégicas e o ajuste de táticas para maximizar resultados."

    },
    {
        date: "Crescimento",
        title: "Cloud",
        category: "Escalabilidade",
        description: "Ambiente altamente escalável, preparado para lidar com grandes volumes de tráfego e demandas crescentes. Isso garante que os afiliados possam expandir suas operações sem preocupações com limitações de infraestrutura, permitindo o crescimento contínuo e sustentável."

    },
]